import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-md) var(--spacing-lg);
  border-bottom: 1px solid var(--color-divider);
  gap: var(--spacing-lg);
`;

const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--color-primary);
  display: flex;
  align-items: center;
  
  svg {
    margin-right: var(--spacing-sm);
  }
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  flex-shrink: 0;
`;

const UserName = styled.span`
  color: var(--color-text);
  font-weight: 500;
`;

const Button = styled.button`
  padding: var(--spacing-sm) var(--spacing-md);
  background-color: transparent;
  color: var(--color-primary);
  border: 1px solid var(--color-primary);
  border-radius: var(--border-radius-sm);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition-default);
  
  &:hover {
    background-color: var(--color-primary);
    color: white;
  }
`;

const Header = ({ user, onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    // Clear user state immediately
    if (onLogout) {
      onLogout();
    }
    
    try {
      await axios.post('/api/auth/logout/', {}, {
        withCredentials: true,
      });
    } catch (err) {
      console.error('Logout error:', err);
      // Continue with logout even if request fails
    }
    
    // Always navigate to login
    navigate('/login');
  };

  return (
    <HeaderContainer>
      <Logo>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17 10.5V7C17 6.73478 16.8946 6.48043 16.7071 6.29289C16.5196 6.10536 16.2652 6 16 6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7V17C3 17.2652 3.10536 17.5196 3.29289 17.7071C3.48043 17.8946 3.73478 18 4 18H16C16.2652 18 16.5196 17.8946 16.7071 17.7071C16.8946 17.5196 17 17.2652 17 17V13.5L21 17.5V6.5L17 10.5Z" 
            fill="#0071e3" stroke="#0071e3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        TranscriptGen
      </Logo>
      
      {user ? (
        <UserInfo>
          <UserName>{user.first_name} {user.last_name}</UserName>
          <Button onClick={handleLogout}>Logout</Button>
        </UserInfo>
      ) : (
        <UserInfo>
          <Button onClick={() => navigate('/login')}>Login</Button>
          <Button onClick={() => navigate('/register')}>Register</Button>
        </UserInfo>
      )}
    </HeaderContainer>
  );
};

export default Header;
